import React, { Component, Fragment } from "react"
import Async from "react-select"
import modalIcon from "../../../assets/images/testIcon.svg"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"

export default class SignOffModule extends Component {
  state = {
    _id: "",
    signOff: [],
    STATUS: [],
    assignedToList: [],
    disabled: false
  }

  componentWillMount() {
    const {
      _id,
      signOffComments,
      signOffProcess,
      STATUS,
      assignedToList,
      disabled
    } = this.props
    this.setState({
      _id,
      signOffComments,
      signOffProcess,
      STATUS,
      assignedToList,
      disabled
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      signOffComments,
      signOffProcess,
      STATUS,
      assignedToList,
      disabled
    } = nextProps
    this.setState({
      _id,
      signOffComments,
      signOffProcess,
      STATUS,
      assignedToList,
      disabled
    })
  }

  render() {
    const { signOffComments, STATUS, assignedToList, disabled } = this.state
    const { permissions } = this.props
    return (
      <Fragment>
        {/* {!disabled && permissions.create && permissions.edit && ( */}
        <div class="card-filter " id="signOff" style={{ marginBottom: ".5%" }}>
          <div class="col-md-12">
            <ModuleHeader
              header={"Sign Off "}
              onClick={this.onOpenModal}
              _id={this.state._id}
              process={this.state.signOffProcess}
              disabled={this.state.disabled}
              updateModulesMain={this.props.updateModulesMain}
              moduleName={"signOff"}
              statusList={STATUS}
            />
            <div class="col-md-12" style={{ paddingBottom: "1%" }}>
              <div class="wash-container">
                {/* <div class="col-md-12 no-padding">
                      <div class="col-md-12 no-padding">
                        <div class="col-md-2 step-one">
                          <div class="form-group">
                            <label for="ref-no">Assigned To</label>
                            <br />
                            <div class="custom-async-select">
                                <Async
                                    name="assignedTo"
                                    value={value.assignedTo}
                                    // onInputChange={this.getFabricNumber}
                                    // onChange={(value) => this.props.getFabricInfo(value,index)}
                                    placeholder="Find AssignedTo"
                                    options={this.state.assignedToList}
                                    disabled = {true}
                                />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 step-one">
                          <Field
                              isFormGroup={true}
                              inputType="select"
                              inputName="status"
                              value={value.status}
                              options={STATUS}
                              index ={index}
                              label ={"Status"}
                              onChange={this.props.updateSignOff}
                              disabled={this.state.disabled}
                            />
                        </div>
                        <div class="col-md-2 step-one">
                          <Field
                              isFormGroup={true}
                              inputType="date"
                              inputName="completedDate"
                              label="Completed Date"
                              value={signOffProcess.completedDate}
                              index ={index}
                              onChange={this.props.updateSignOff}
                              disabled={this.state.disabled}
                            />
                        </div>
                      </div>
                    </div> */}
                <div class="col-md-12 step-one">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName="signOffComments"
                    value={signOffComments}
                    label="comments"
                    onChange={this.props.updateSignOff}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <div className="col-md-12 padding-top text-center profile-btn">
                    <Button
                      buttonType="save"
                      buttonName="save"
                      onClick={this.props.createSignOff}
                    />
                    <Button
                      buttonType="save"
                      buttonName="Complete"
                      onClick={this.props.completeSignoff}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
        {/* )} */}
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/SignOffModule/index.js